const ApiResponseUnmapper = require('../libraries/DigiTickets/Api/ApiResponseUnmapper');

const ReturnReasonResource = function ($resource, ApiRequestParams, AppConfig, ReturnReasonCache) {
    return $resource(
        AppConfig.apiBaseUrl + 'returnreasons',
        ApiRequestParams.defaults(),
        {
            query: {
                cache: ReturnReasonCache,
                isArray: true,
                method: 'GET',
                params: ApiRequestParams.defaultMappers(),
                transformResponse: (json) => ApiResponseUnmapper.transformApiResponse(json, 'ReturnReason')
            }
        }
    );
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ReturnReasonResource;
}
